import { ReactElement, useState } from 'react';
import {
  Links,
  LinkSection,
  MenuLink,
  Title,
  ToggleButton,
  Wrapper,
} from './Menu.elements';
import { IoClose, IoMenu } from 'react-icons/io5';

export type MenuItem = {
  text: string;
  path?: string;
};

export const Menu = (): ReactElement => {
  const [showMenu, setShowMenu] = useState(false);

  const items: Array<MenuItem | string> = [
    {
      text: 'Home',
      path: '/',
    },
    {
      text: 'About Me',
      path: '/about',
    },
    {
      text: 'Contact Me',
      path: '/contact',
    },
  ];

  return (
    <Wrapper>
      <Title>
        <MenuLink to="/">Chris Davis</MenuLink>
      </Title>
      <LinkSection>
        {items && (
          <Links $visible={showMenu}>
            {items.map((item, index) =>
              typeof item === 'string' ? (
                item
              ) : (
                <MenuLink
                  key={`menu-item-${index}`}
                  to={item.path ?? '/'}
                  onClick={() => setShowMenu(false)}
                >
                  {item.text}
                </MenuLink>
              ),
            )}
          </Links>
        )}
        <ToggleButton onClick={() => setShowMenu(!showMenu)}>
          {showMenu ? <IoClose /> : <IoMenu />}
        </ToggleButton>
      </LinkSection>
    </Wrapper>
  );
};
